import { render, staticRenderFns } from "./invoiceManagement.vue?vue&type=template&id=15a4dda4&scoped=true"
import script from "./invoiceManagement.vue?vue&type=script&lang=js"
export * from "./invoiceManagement.vue?vue&type=script&lang=js"
import style0 from "./invoiceManagement.vue?vue&type=style&index=0&id=15a4dda4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4dda4",
  null
  
)

export default component.exports